import React, { createContext, useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import api from '../app/api';
import { DeleteAlert, UpdateAlert } from '../components/Swal Alert';
import { capitalFirstLetter } from '../config/functions';
import useAlert from './useAlert';

const FormContext = createContext();

function FormState(props) {
    const [loading, setLoading] = useState(null)
    const { showAlert } = useAlert()
    const [data, setData] = useState({
        title: "",
        questions: [],
    });
    const [question, setQuestion] = useState({
        question: "",
        type: "",
        hintText: "",
        options: [],
        yes: "",
        no: "",
        required: false,
    });
    const onDublicateQuestiuon = (question, index) => {
        var questions = [...data.questions];
        if (index == undefined) {
            questions.push(question);
        } else {
            questions = [
                ...questions.slice(0, index + 1),
                question,
                ...questions.slice(index + 1),
            ];
        }

        setData({ ...data, questions });
    };
    const navigate = useNavigate()
    const newForm = async () => {
        setLoading("new");
        try {
            const response = await api.post("/form/add", { ...data });
            if (response.data.status) {
                setData({
                    title: "",
                    questions: [],
                });
                showAlert("New form added", "success");
                navigate("/form-list");
            } else {
                showAlert(response.data.message, "danger");
            }
            setLoading(false);
        } catch (err) {
            const message = err.response
                ? err.response.data?.message
                    ? err.response.data?.message
                    : err.response.data
                : err;
            showAlert(capitalFirstLetter(message), "danger");
            setLoading(false);
        }
    };
    const onAddQuestiuon = (
        e,
        sortIndex,
        setSortIndex,
        editIndex,
        setEditIndex
    ) => {
        e.preventDefault();
        var questions = [...data.questions];
        if (editIndex || editIndex == 0) {
            questions.splice(editIndex, 1);
            setEditIndex(undefined);
        }
        if (sortIndex) {
            questions.splice(sortIndex - 1, 0, question);
            setSortIndex(questions.length + 1);
        } else {
            questions.push(question);
        }
        setData({ ...data, questions });
        setQuestion({
            question: "",
            type: "",
            hintText: "",
            options: [],
            yes: "",
            no: "",
            required: false,
        });
    };
    const changeForm = async () => {
        if (!(await UpdateAlert())) return;
        setLoading("update");
        try {
            let response = await api.put(
                `/form/update`,
                data
            );
            if (response.data.status) {
                setData({ ...data });
                showAlert(
                    "Form updated successfully",
                    "success"
                );
                navigate("/form-list");
            } else {
                showAlert(response.data.message, "danger");
            }
            setLoading(false);
        } catch (err) {
            const message = err.response
                ? err.response.data?.message
                    ? err.response.data?.message
                    : err.response.data
                : err;
            setLoading(false);
            showAlert(message, "danger");
        }
    };
    const removeForm = async (form) => {
        if (!(await DeleteAlert())) return;
        setLoading("delete");
        try {
            const response = await api.delete(
                `/form/delete?_id=${form ? form._id : data._id}`
            );
            if (response.data.status) {
                if (!form) navigate("/form-list");
                showAlert("Form removed successfully", "success");
            } else {
                showAlert(response.data.message, "danger");
            }
            setLoading(false);
        } catch (err) {
            const message = err.response
                ? err.response.data?.message
                    ? err.response.data?.message
                    : err.response.data
                : err;
            showAlert(message, "danger");
            setLoading(false);
        }
    };
    const [sortOrder, setSortOrder] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const titleField = {
        value: data?.title,
        setValue: (value) => setData({ ...data, title: value }),
        placeholder: 'Enter form title',
        type: 'text',
        id: 'formTitle'
    }
  return (
    <FormContext.Provider
      value={{
        loading, setLoading,
        data, setData,
        question, setQuestion,
        onDublicateQuestiuon,
        newForm,
        onAddQuestiuon,
        changeForm,
        removeForm,
        sortOrder, setSortOrder,
        editIndex, setEditIndex,
        titleField
      }}
    >
      {props.children}
    </FormContext.Provider>
  );
}
export { FormContext, FormState };
